import { ArrowUp } from '../../../icons'
import {
  Container,
  PagNumberBtn,
  PagPrevNextBtn
} from './styles'

const Pagination = ({
  currentPage,
  totalPages,
  onChange
}) => {

  const isFirstPage = currentPage === 0
  const isLastPage = currentPage === totalPages - 1

  return (
    <Container>
      <PagPrevNextBtn
        variant='creators'
        disabled={isFirstPage}
        onClick={() => onChange(currentPage-1)}
      >
        <ArrowUp transform='rotate(-90)' width={13} height={13} />
        Anterior
      </PagPrevNextBtn>

      {Array(totalPages).fill().map((_, idx) => (
        <PagNumberBtn
          variant='creators'
          $isActive={idx === currentPage}
          onClick={() =>onChange(idx)}
        >
          {idx + 1}
        </PagNumberBtn>
      ))}

      <PagPrevNextBtn
        variant='creators'
        disabled={isLastPage}
        onClick={() => onChange(currentPage+1)}
      >
        Siguiente
        <ArrowUp transform='rotate(90)' width={13} height={13} />
      </PagPrevNextBtn>
    </Container>
  )
}

export default Pagination